storeReader